import React, { useState }  from 'react';
import { Button, FormControl, MenuItem, Modal, makeStyles } from '@material-ui/core';
import axios from 'axios';
import { connect } from 'redux-zero/react';
import actions from '../../actions';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import SharpTextField from '../SharpTextField';
import SharpSelectField from '../SharpSelectField';

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 500
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 800
    },
    formControlFullWidth: {
        margin: theme.spacing(1, 0),
        width: '100%',
    },
}));

const mapToProps = ({ selectedSociety }) => ({ selectedSociety });

function AccountGroupEdit({ selectedSociety, mode, model, onClose }) {
    const classes = useStyles();
    const [error, setError] = useState('');

    function onSubmit(value) {
        setError('');

        if (mode === 'Create') {
            axios({
                method: 'POST',
                url: '/accountgroup',
                headers: { 'X-SocietyId': selectedSociety },
                data: JSON.stringify(value)
            })
                .then(response => {
                    onClose();
                })
                .catch(error => {
                    setError(error.response.data.message);
                });
        } else if (mode === 'Edit') {
            axios({
                method: 'PUT',
                url: '/accountgroup/' + model.id,
                headers: { 'X-SocietyId': selectedSociety },
                data: JSON.stringify(value)
            })
                .then(response => {
                    onClose();
                })
                .catch(error => {
                    setError(error.response.data.message);
                });
        }
    }

    return (
        <Modal className={classes.modal} open={(model != null)} onClose={onClose}>
            <div className={classes.paper}>
                <h2 id="transition-modal-title">{mode} Account Group</h2>
                <Formik initialValues={model}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        code: Yup.number().required('Required').min(100).max(999),
                        name: Yup.string().required('Required')
                    })}
                    validateOnMount={true}
                    onSubmit={onSubmit}
                >
                    {({ isValid }) => (
                        <Form autoComplete="off" onKeyDown={(e) => { if (e.keyCode === 13 && e.target.id !== 'save') e.preventDefault(); }}>
                            <div>
                                <FormControl className={classes.formControlFullWidth}>
                                    <SharpTextField
                                        id="code"
                                        name="code"
                                        label="Code"
                                        type="number"
                                        fullWidth
                                        disabled={model.isSystem}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('name').focus(); } }}
                                    />
                                </FormControl>
                            </div>
                            <div>
                                <FormControl className={classes.formControlFullWidth}>
                                    <SharpTextField
                                        id="name"
                                        name="name"
                                        label="Name"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('collapseInReports').focus(); } }}
                                    />
                                </FormControl>
                            </div>
                            <div>
                                <FormControl className={classes.formControlFullWidth}>
                                    <SharpSelectField
                                        id="collapseInReports"
                                        name="collapseInReports"
                                        label="Report Appearance"
                                        fullWidth
                                        disabled={model.isSystem}
                                        onKeyUp={(e) => { if (e.keyCode === 13) { document.getElementById('save').focus(); } }}
                                    >
                                        <MenuItem value={true}>Total only</MenuItem>
                                        <MenuItem value={false}>Detailed</MenuItem>
                                    </SharpSelectField>
                                </FormControl>
                            </div>
                            <div>
                                {error}
                            </div>
                            <div>
                                <Button id="save" variant="contained" color="primary" type="submit" disabled={!isValid}>
                                    Save
                            </Button>
                                <Button variant="contained" color="secondary" type="submit" onClick={() => { setError(''); onClose();}}>
                                    Cancel
                            </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </Modal>
    );
}

export default connect(mapToProps, actions)(AccountGroupEdit);